import { forwardRef } from 'react'
import { Box } from '@mui/material'

import logoSrc from '../assets/logo.png'
import logoMarkSrc from '../assets/logo_mark.png'
import logoRentSrc from '../assets/logo_pop_rent.png'
import logoEstateSrc from '../assets/logo_pop_estate.png'
import logoVerticalSrc from '../assets/logo_vertical.png'

const variantSources = {
  mark: logoMarkSrc,
  rent: logoRentSrc,
  estate: logoEstateSrc,
  vertical: logoVerticalSrc,
}

export const CompanyLogo = forwardRef(function CompanyLogo(
  { src, variant, alt = 'Pop Estate', sx, ...props },
  ref,
) {
  const resolvedSrc = src ?? (variant ? variantSources[variant] : logoSrc)

  return (
    <Box
      component="img"
      ref={ref}
      src={resolvedSrc}
      alt={alt}
      sx={{ display: 'block', width: 160, height: 'auto', ...sx }}
      {...props}
    />
  )
})
